import React, {useState, useEffect} from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import {lightTheme, darkTheme} from './util/theme'
import { ThemeProvider } from '@material-ui/core'
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {Container, Grid} from '@material-ui/core'
import { FaGithub, FaLinkedin } from 'react-icons/fa';


import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProjectsPage from './pages/ProjectsPage';
import ContactPage from './pages/ContactPage';
import Socials from './components/Socials';

import '../css/App.css'

function V1_App() {

    const [theme, setTheme] = useState(lightTheme);
    const [lightOrDark, setLightOrDark] = useState('light');
    
    const handleLightOrDark = event => {
        const colorMode = lightOrDark === 'light' ? 'dark' : 'light';
        setLightOrDark(colorMode);
        
        const colorTheme = theme === lightTheme ? darkTheme : lightTheme;
        setTheme(colorTheme);
    };

    let BACKGROUND_COLOR = theme.palette.background.default
    
    const useStyles = makeStyles(theme => ({
        root: {
            width: '100vw',
            padding: 0,
            background: BACKGROUND_COLOR,
        },
    }))
    const classes = useStyles();


    return (
        <ThemeProvider theme={{...theme}}>
            <Router>
                <Container maxWidth="xl" className={classes.root}>
                    {/* pages */}
                    <Navbar lightOrDark={lightOrDark} handleLightOrDark={handleLightOrDark}/>
                    <HomePage/>

                    {/* routes */}
                    <Switch>
                        <Route exact path='/' compponent={<HomePage/>} />
                    </Switch>
                </Container>
            </Router>
        </ThemeProvider>
    )
}

export default V1_App;
